import {CartesianGrid, Legend, Line, LineChart, Tooltip, XAxis, YAxis} from 'recharts';

import {useForm} from 'react-hook-form';
import React, {useState} from 'react';

import {paymentAPI} from 'entities/payment';

import SpinnerWithOverlay from 'shared/ui/SpinnerWithOverlay/SpinnerWithOverlay';

import Select from '../../../../../shared/ui/Select/Select';
import MainModal from '../../../../../shared/ui/Modal/MainModal';

import HintQuestion from '../../../../../shared/ui/Hint/HintQuestion';

import createHttpRequest from '../../../../../shared/api/http';
import {ApiUrls} from '../../../../../shared/config/model/urls';

import styles from '../Users.module.scss';

interface PlotStatItem {
    month: string,
    s: number,
    noSub: number,
    withSub: number
}

interface YearItem {
    label: string,
    value: string
}

const PaymentUserListStatsWidget: React.FC = () => {
    const {data, isLoading} = paymentAPI.useGetPaymentUserStatsQuery();
    const [modalOpen, setIsModalOpen] = useState(false);
    const handleClose = () => setIsModalOpen(false);
    const [isFetchingModal, setIsFetchingModal] = useState(true);
    const [years, setYears] = useState<YearItem[]>([]);
    const [statsData, setStatsData] = useState<PlotStatItem[]>([]);
    const { control, setValue } = useForm<{year: string}>({
        mode: 'onChange',
    });

    const monthNumToLabel: any = {
        '01': 'янв.',
        '02': 'фев.',
        '03': 'мар.',
        '04': 'апр.',
        '05': 'мaй',
        '06': 'июнь',
        '07': 'июль',
        '08': 'авг.',
        '09': 'сен.',
        10: 'окт.',
        11: 'ноя.',
        12: 'дек.',
    };

    const fetchPlot = async(selectedYear: any) => {
        setIsFetchingModal(true);
        try {
            const response = await createHttpRequest({
                method: 'GET',
                path: ApiUrls.PAYMENT_USER_STATS_PLOT_DATA(Number(selectedYear)),
                errorMessage: 'Произошла ошибка',
                silent: true,
                isAnonymous: false,
            });

            const year: string = (response.data.year ?? '') as string;
            const years: string[] = (response.data.years ?? []) as string[];
            const plot: PlotStatItem[] = ((response.data.plot ?? []) as PlotStatItem[]).map((item) => {
                item.month = monthNumToLabel[item.month];
                return item;
            });
            plot.unshift({month: '', s: 0, withSub: 0, noSub: 0});

            setValue('year', year, {shouldDirty: true});

            setYears(years.map(method => ({
                label: method,
                value: method,
            })));
            setStatsData(plot);

        } catch (e) {

        } finally {
            setIsFetchingModal(false);
        }
    };

    const handleOpenModal = async() => {
        setIsModalOpen(true);
        await fetchPlot(null);
    };

    if(isLoading) {
        return (
            <>
                <div className={styles.stats}>
                    <SpinnerWithOverlay overlay={false}/>
                </div>
            </>
        );
    }

    let modalHtml;

    if(isFetchingModal) {
        modalHtml = (
            <>
                <SpinnerWithOverlay overlay={false}/>
            </>
        );
    } else {
        modalHtml = (
            <>
                <LineChart
                    width={900}
                    height={400}
                    data={statsData}

                >
                    <CartesianGrid strokeDasharray="3 3" />
                    <XAxis dataKey="month" />
                    <YAxis />
                    <Tooltip />
                    <Legend />
                    <Line name={'Всё'} type="monotone" dataKey="s" stroke="#8884d8" activeDot={{ r: 8 }} />
                    <Line name={'Разовые'} type="monotone" dataKey="noSub" stroke="#82ca9d" />
                    <Line name={'Рекуррентные'} type="monotone" dataKey="withSub" stroke="#f90199" />
                </LineChart>
            </>
        );
    }

    return (
        <>
            <div className={styles.stats}>
                <a
                    className={styles.linkContent}
                    onClick={handleOpenModal}
                >
                    {data?.prev_month.all_paid_sum} руб. <HintQuestion placement="bottom">
                        <>
                            <p>Сумма оплат за предыдущий КАЛЕНДАРНЫЙ месяц</p>
                        </>
                    </HintQuestion>
                </a>
                <a
                    className={styles.linkContent}
                    onClick={handleOpenModal}
                >
                    {data?.month.subscription} руб. <HintQuestion placement="bottom">
                        <>
                            {/* eslint-disable-next-line max-len */}
                            <p>Расчётный суммарный рекуррентный платеж на текущий момент (сумма платежей пользователей с подключенной автооплатой)</p>
                        </>
                    </HintQuestion>
                </a>
            </div>
            <MainModal
                header="Детализация оплат за год"
                open={modalOpen}
                handleClose={handleClose}
                size="lg"
            >
                <form>
                    <Select
                        onChange={fetchPlot}
                        rules={{required: 'Год'}}
                        name="year"
                        data={years}
                        control={control}
                        placeholder="Год"
                        cleanable={false}
                        searchable={false}
                    />
                </form>
                <hr/>

                {modalHtml}

            </MainModal>
        </>
    );
};

export default PaymentUserListStatsWidget;